const operatorConverter = {
    '+': '-',
    '-': '+',
};

function getSignedSpecifierPair(value: string | null): Tuple<string, 2> {
    if (!value) {
        return ['-', '-'];
    }

    const floatValue = parseFloat(value);

    if (floatValue === 0) {
        return ['0', '0'];
    }

    const isLessThanZero = value.includes('-');

    const firstOperator = isLessThanZero ? '-' : '+';

    const firstValue = isLessThanZero ? value : `${firstOperator}${value}`;

    const secondValue = firstValue.replace(
        firstOperator,
        operatorConverter[firstOperator]
    );

    return [firstValue, secondValue];
}

export default getSignedSpecifierPair;
